import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['ERHALTEN'],
    small: ['RAD', 'ERHALTEN'],
}

export const TextHeaderDe = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="DREHEN SIE DAS RAD UND ERHALTEN SIE FREISPIELE"
            highlights={[{ word: 'SIE' }, { word: 'FREISPIELE' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
